var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-default',[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("404!")]),_c('div',{staticClass:"error"},[_vm._v(" The requested page isn't in existence. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }